(() => {
  const name = 'editorialPage';

  App.common = App.common || {};

  App.common[name] = (() => {
    const setEventListeners = () => {
      const $editorialPageCTA = $('[data-editorial-page-cta]');
      const isQuestionaryEnabled = $('[data-react-module="editorial-quiz-modal"]').length;

      if (isQuestionaryEnabled) {
        $editorialPageCTA.on('click', (e) => {
          e.preventDefault();
          App.eventBus.trigger('editorialQuizModal:open');
        });
      }
    };

    const init = () => {
      setEventListeners();
    };

    return {
      init,
    };
  })();
})();
